export interface ContactFormState {
    name: string | null;
    emails: ContactEmailFormState[];
    phones: ContactPhoneFormState[];
    contactCompany: string | null;
    ownerUserId: number | null;
}

export interface ContactEmailFormState {
    id?: number;
    _key: string;
    levelId?: number;
    email: string | null;
    isMain: boolean;
}

export interface ContactPhoneFormState {
    id?: number;
    _key: string;
    levelId?: number;
    number: string | null;
    isMain: boolean;
}
